import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Box, Button, Paper, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { candidateInitialValues } from "../../../../constant/appConstant";
import fetcher from "../../../../dataProvider";
import {
  setLoading,
  setToastData,
} from "../../../../redux/slices/customerJourney";
import {
  setExamRulesData,
  setLookupData,
} from "../../../../redux/slices/examDetails";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { ReasonForExam, stepCancelProps } from "../../../../types/common";
import {
  getCountryId,
  getLanguageCode,
  getSelectedCountry,
} from "../../../../utils/common";
import GetInvoiceLabels from "../../../../utils/getInvoiceLabels";
import getLookupDropdownList from "../../../../utils/getLookupDropdownList";
import OrderCard from "../../../common/Card";
import Input from "../../../common/FormComponents/Input";
import RadioLabelGroup from "../../../common/FormComponents/RadioGroup";
import Select from "../../../common/FormComponents/Select";
import AddressInfo from "./AddressInfo";
import AnotherPerson from "./AnotherPerson";
import GuardianForm from "./Guardian";
import Passport from "./Passport";
import PersonalInfo from "./PersonalInfo";
import styles from "./styles";
import isDateLessThanToday from "../../../../utils/getCheckDateLessThanToday";
import Popup from "../../../common/Modal";
import { useCandidateDetails } from "./useCandidateDetails";
import FormSectionHeader from "../../../common/Form/FormSectionHeader";
import FormSectionGrid from "../../../common/Form/FormSectionGrid";
import usePageView from "../../../../utils/analytics/usePageView";
import GTM from "../../../../utils/analytics/gtm";
import { NoSlotsChecker } from "../../../common/NoSlotsChecker";
import { RussiaWarningMsg } from "./RussiaWarningMsg";

const RUSSIA_COUNTRY_ID = "ba533e3a-29ba-4d31-b75d-deaf89a220ad";

const CandidateDetails = (props: stepCancelProps) => {
  usePageView("Candidate Details");
  const { toggleSteps } = props;
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const examDataStore = useAppSelector((state) => state.examDetails);
  const { examRulesData, examLookupData } = examDataStore;
  const candidateData = useCandidateDetails();
  const invoiceTypes = GetInvoiceLabels();
  const [examDetails, setExamDetails] = useState<any>(null);
  const [emailError, setEmailError] = useState<any>(false);
  const [confirmEmailError, setConfirmEmailError] = useState<any>(false);
  const [guradianEmailError, guardianSetEmailError] = useState<any>(false);
  const [guardianConfirmEmailError, guardianSetConfirmEmailError] =
    useState<any>(false);
  const [invoiceEmailError, setInvoiceEmailError] = useState<any>(false);
  const [getConfirmEmail, setConfirmEmail] = useState<any>(
    candidateData?.confirmEmail || ""
  );
  const [phoneNumber, setPhoneNumber] = useState<any>(
    candidateData?.phoneNo ? candidateData?.phoneNo : ""
  );
  const [telephoneNumber, setTelephoneNumber] = useState<any>(
    candidateData?.telephoneNo ? candidateData?.telephoneNo : ""
  );
  const [dobError, setDobError] = useState<any>(false);
  const [ukVisa, setUkVisa] = useState<any>(false);
  const [givenNameEnable, setGivenNameEnable] = useState<any>(false);
  const [requestType, setRequestType] = useState<boolean>();
  const [invoiceType, setInvoiceType] = useState(
    candidateData?.invoiceType || "myself"
  );
  const country = getSelectedCountry();
  const [getAge, setAge] = useState<any>(
    candidateData?.age ? candidateData?.age : null
  );
  const [showMinAge, setShowMinAge] = useState(false);
  const [showMaxAge, setShowMaxAge] = useState(false);
  const [taxNumberValid, setTaxNumber] = useState(false);
  const [open, setOpen] = useState(false);
  const [showGuardianFields, setShowGuardianFields] = useState(false);
  const { pageText, countryList } = customerJourney;
  const [emailValue, setEmailValue] = useState("");
  const [showThirdParty, setShowThirdParty] = useState(
    candidateData?.enableThirdParty?.label === "Yes" ? true : false
  );
  const [showCompanyThirdParty, setShowCompanyThirdParty] = useState(false);
  const dispatch = useAppDispatch();
  const [lookupDropdownData, setLookupDropdownData] = useState<any>();
  const { control, formState, handleSubmit, setValue, clearErrors, watch } =
    useForm({
      mode: "all",
      criteriaMode: "all",
      defaultValues: candidateData
        ? {
            ...candidateData,
            MarketingConsent: candidateData?.MarketingConsent
              ? candidateData?.MarketingConsent
              : "",
          }
        : candidateInitialValues,
    });

  const thirdPartyCountry = watch("thirdPartyCountry");
  const countries = watch(["country", "another.country", "company.country"]);
  const russiaSelected =
    countries.map((x) => x?.value).includes(RUSSIA_COUNTRY_ID) ||
    (thirdPartyCountry?.value === RUSSIA_COUNTRY_ID && showThirdParty);

  const marketingOptions = [
    {
      label: pageText?.labelsMetadata?.marketingConsentParagraph1,
      value: 1,
      disabled: false,
      checked: false,
    },
    {
      label: pageText?.labelsMetadata?.marketingConsentParagraph2,
      value: 2,
      disabled: false,
      checked: false,
    },
    {
      label: pageText?.labelsMetadata?.marketingConsentParagraph3,
      value: 3,
      disabled: false,
      checked: false,
    },
  ];

  const handleEmailChange = (e: any) => {
    const emailValue = e.target.value;
    if (getConfirmEmail && emailValue !== getConfirmEmail) {
      setConfirmEmailError(true);
    }
    if (emailValue === getConfirmEmail) {
      setConfirmEmailError(false);
    }
  };

  useEffect(() => {
    if (examLookupData) {
      const data = getLookupDropdownList(
        examLookupData,
        examDetails?.isExamEligibleForUkVisa
      );
      setLookupDropdownData(data);
    }
  }, [examLookupData]);

  useEffect(() => {
    let data: any = sessionStorage.getItem("examDetails");
    let examRules: any = sessionStorage.getItem("examRulesData");
    data = JSON.parse(data);
    examRules = JSON.parse(examRules);
    setExamDetails(data);
    dispatch(setExamRulesData({ details: examRules }));
    if (
      candidateData?.examReason.value === ReasonForExam.UKVisaPurposes &&
      data?.isExamEligibleForUkVisa
    ) {
      setUkVisa(true);
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const getDate = (data: string) => {
    const date = new Date(data);
    return `${
      date.getMonth() <= 8 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
    }/${
      date.getDate() <= 9 ? "0" + date.getDate() : date.getDate()
    }/${date.getFullYear()}`;
  };

  const onFormSubmit = async (values: any) => {
    if (showMaxAge || showMinAge) {
      setOpen(true);
    } else {
      if (
        !(
          confirmEmailError ||
          emailError ||
          invoiceEmailError ||
          guradianEmailError ||
          guardianConfirmEmailError ||
          taxNumberValid ||
          (showMaxAge && showMinAge)
        )
      ) {
        let EIITaxNumberFormat: any =
          examRulesData?.examRegistrationRules?.eiiTaxNumberFormat;
        EIITaxNumberFormat = new RegExp(EIITaxNumberFormat);
        if (
          examDetails?.isExamEligibleForUkVisa 
        ) {
          const passportExValidDate =
            isDateLessThanToday(
              `${values?.passportEx?.month?.value}/${values?.passportEx?.day?.value}/${values?.passportEx?.year?.value}`
            ) ||
            isDateLessThanToday(
              `${values?.passportEx?.month?.value}/${values?.passportEx?.day?.value}/${values?.passportEx?.year?.value}`,
              getDate(examDetails?.examDate)
            );
          if (passportExValidDate) {
            dispatch(
              setToastData({
                toastData: {
                  message:
                    pageText.validationMessages
                      .passportExpiryDateExpiresBeforeExam,
                  open: true,
                  type: "failure",
                },
              })
            );
            return;
          }
        }
        sessionStorage.setItem(
          "candidateDetails",
          JSON.stringify({
            ...values,
            age: getAge,
            haveFamilyName: givenNameEnable ? "1" : "0",
            languageCode: getLanguageCode(),
          })
        );
        GTM.addShippingInfo(examDetails);
        toggleSteps("confirmation", 4);
      }
    }
  };

  const onTaxNumberChange = (e: any) => {
    const value = e.target.value;
    let EIITaxNumberFormat: any =
      examRulesData?.examRegistrationRules?.eiiTaxNumberFormat;
    EIITaxNumberFormat = new RegExp(EIITaxNumberFormat);
    if (!EIITaxNumberFormat.test(value) && value !== "") {
      setTaxNumber(true);
    } else {
      setTaxNumber(false);
    }
  };

  const { errors } = formState;

  const invoiceFormRender: any = {
    myself: (
      <FormSectionGrid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="myself.taxNumber"
            control={control}
            placeholder={pageText?.labelsMetadata.taxNumberForMySelfLabel}
            errors={errors}
            outsideError={
              taxNumberValid
                ? pageText?.validationMessages.pleaseEnterVATNumber
                : undefined
            }
            maxLength={30}
            onTaxNumber={onTaxNumberChange}
            label={pageText?.labelsMetadata.taxNumberForMySelfLabel}
          />
        </Grid>
      </FormSectionGrid>
    ),
    another: (
      <AnotherPerson
        lookupDropdownData={lookupDropdownData}
        control={control}
        errors={errors}
        setGivenNameEnable={(value: boolean) => setGivenNameEnable(value)}
        pageText={pageText}
        examRulesData={examRulesData}
        clearErrors={clearErrors}
        taxNumberValid={taxNumberValid}
        candidateData={candidateData}
        onTaxNumberChange={onTaxNumberChange}
        setTaxNumber={setTaxNumber}
        setInvoiceEmail={setInvoiceEmailError}
        invoiceEmailError={invoiceEmailError}
        setValue={setValue}
      />
    ),
    company: (
      <AnotherPerson
        control={control}
        errors={errors}
        clearErrors={clearErrors}
        pageText={pageText}
        examRulesData={examRulesData}
        setInvoiceEmail={setInvoiceEmailError}
        taxNumberValid={taxNumberValid}
        setValue={setValue}
        setTaxNumber={setTaxNumber}
        onTaxNumberChange={onTaxNumberChange}
        invoiceEmailError={invoiceEmailError}
        type="company"
        lookupDropdownData={lookupDropdownData}
      />
    ),
  };

  const togglePhoneNumber = (e: any, type = "") => {
    const value = e.target.value;
    const regex = /^[0-9]*$/;
    if (regex.test(value)) {
      type === "telephone" ? setTelephoneNumber(value) : setPhoneNumber(value);
    }
    if (value === "") {
      setPhoneNumber(value);
    }
  };

  const getLookupData = async () => {
    dispatch(setLoading({ loading: true }));
    try {
      const countryId = getCountryId(countryList);
      let languageCode = getLanguageCode();
      if (languageCode && countryId) {
        const { data } = await fetcher.get(
          `/api/LookupData/GetLookupData?languageCode=${languageCode}`
        );
        dispatch(setLookupData({ details: data }));
      }
      // dispatch(setLoading({ loading: false }));
    } catch (e) {
      dispatch(setLoading({ loading: false }));
      console.log("Error ", e);
      dispatch(
        setToastData({
          toastData: {
            message: pageText?.labelsMetadata?.somethingwrong,
            open: true,
            type: "failure",
          },
        })
      );
    }
  };

  const getExamRules = async () => {
    dispatch(setLoading({ loading: true }));
    try {
      let examData: any = sessionStorage.getItem("examDetails");
      examData = JSON.parse(examData);
      const countryId = getCountryId(countryList);
      let languageCode = getLanguageCode();
      if (languageCode && countryId) {
        const { data } = await fetcher.get(
          `/api/Exam/?languageCode=${languageCode}&id=${examData.examId}&alias=${countryId?.textValue}`
        );
        dispatch(setExamRulesData({ details: data }));
        sessionStorage.setItem("examRulesData", JSON.stringify(data));
      }
      dispatch(setLoading({ loading: false }));
    } catch (e) {
      console.log("Error ", e);
      dispatch(setLoading({ loading: false }));
      dispatch(
        setToastData({
          toastData: {
            message: pageText?.labelsMetadata?.somethingwrong,
            open: true,
            type: "failure",
          },
        })
      );
    }
  };

  const errorAutoScroll = () => {
    const errorEle = document.getElementsByClassName("MuiFormHelperText-root");
    if (errorEle.length > 0) {
      errorEle[0].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  useEffect(() => {
    clearErrors();
    getExamRules();
    getLookupData();
  }, [pageText]);

  const getPastYearsList = () => {
    const currentYear = new Date().getFullYear();
    const pastYears = [];
    for (let i = currentYear; i >= currentYear - 85; i--) {
      pastYears.push({ label: i, value: i });
    }
    return pastYears;
  };

  const pastYearsList = getPastYearsList();

  const DayList = Array.from({ length: 31 }, (_, index) => index + 1).map(
    (item) => {
      return { value: item, label: item };
    }
  );

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const regex = /<([a-z1-6]+)\s*>\s*<\/\1>/i;
    if (
      examRulesData?.examRegistrationRules?.validateMaxAge ||
      examRulesData?.examRegistrationRules?.validateMinAge
    ) {
      if (
        getAge &&
        examRulesData?.examRegistrationRules?.minAge > getAge &&
        !regex.test(examRulesData?.examRegistrationRules?.minAgeMessage) &&
        examRulesData?.examRegistrationRules?.minAgeMessage
      ) {
        setShowMinAge(true);
        setShowMaxAge(false);
        setOpen(true);
      } else if (
        getAge &&
        examRulesData?.examRegistrationRules?.maxAge < getAge &&
        !regex.test(examRulesData?.examRegistrationRules?.maxAgeMessage) &&
        examRulesData?.examRegistrationRules?.maxAgeMessage
      ) {
        setShowMinAge(false);
        setShowMaxAge(true);
        setOpen(true);
      } else {
        setShowMinAge(false);
        setShowMaxAge(false);
      }
    }
  }, [getAge]);

  useEffect(() => {
    if (
      !!getAge &&
      examRulesData?.examRegistrationRules &&
      getAge < examRulesData?.examRegistrationRules.guardianAgeLimit &&
      examRulesData?.examRegistrationRules?.showGuardianFields
    ) {
      setShowGuardianFields(true);
      setValue("email", "");
      setValue("confirmEmail", "");
    } else {
      setShowGuardianFields(false);
    }
  }, [getAge, examRulesData]);

  return (
    <>
      <Stack
        sx={styles.wrapper}
        mt={11}
        mb={10}
        direction={{ md: "row-reverse" }}
        justifyContent="space-between"
        gap={2}
      >
        <OrderCard examDetails={examDetails} variant="grey" />
        <Paper component={Box} sx={styles.candidateBox} p={{ xs: 2, md: 3 }}>
          <Box className="main_label">
            {pageText?.textMetadata?.candidatedetails}
          </Box>
          <Box
            component={"form"}
            onSubmit={handleSubmit(onFormSubmit)}
            sx={styles.formBox}
          >
            <PersonalInfo
              dobError={dobError}
              control={control}
              errors={errors}
              pageText={pageText}
              setAge={setAge}
              lookupDropdownData={lookupDropdownData}
              candidateData={candidateData}
              pastYearsList={pastYearsList}
              DayList={DayList}
              getLanguageCode={getLanguageCode}
            />
            {showGuardianFields && (
              <GuardianForm
                control={control}
                errors={errors}
                examRules={examRulesData}
                pageText={pageText}
                emailGuardian={(value: boolean) => guardianSetEmailError(value)}
                confirmEmailGuardian={(value: boolean) =>
                  guardianSetConfirmEmailError(value)
                }
                candidateData={candidateData}
              />
            )}
            <AddressInfo
              lookupDropdownData={lookupDropdownData}
              control={control}
              errors={errors}
              pageText={pageText}
            />
            <Box id="contactInfo">
              <FormSectionHeader>
                {pageText?.textMetadata?.contactinfotext}
              </FormSectionHeader>
              <FormSectionGrid>
                <Grid xs={12} sm={6} className="field">
                  <Input
                    name="phoneNo"
                    control={control}
                    placeholder={
                      pageText?.validationMessages
                        ?.pleaseEnterPhoneOrMobileNumber
                    }
                    placeholderPopup
                    errors={errors}
                    value={phoneNumber}
                    noUseFieldValue={true}
                    onPhoneChange={togglePhoneNumber}
                    label={
                      showGuardianFields
                        ? `${pageText?.labelsMetadata.mobileLabel} ${pageText?.labelsMetadata?.candidate16orabove}`
                        : `${pageText?.labelsMetadata.mobileLabel} *`
                    }
                    rules={{
                      required: showGuardianFields
                        ? false
                        : pageText?.validationMessages
                            ?.pleaseEnterPhoneOrMobileNumber,
                    }}
                  />
                </Grid>
                <Grid xs={12} sm={6} className="field">
                  <Input
                    name="telephoneNo"
                    control={control}
                    placeholder={
                      pageText?.validationMessages
                        ?.pleaseEnterPhoneOrMobileNumber
                    }
                    placeholderPopup
                    errors={errors}
                    noUseFieldValue={true}
                    value={telephoneNumber}
                    onPhoneChange={(e: any) =>
                      togglePhoneNumber(e, "telephone")
                    }
                    label={
                      showGuardianFields
                        ? `${pageText?.labelsMetadata.telephonenumberAlternativemobilenumber} ${pageText?.labelsMetadata?.candidate16orabove}`
                        : `${pageText?.labelsMetadata.telephonenumberAlternativemobilenumber} *`
                    }
                    rules={{
                      required: showGuardianFields
                        ? false
                        : pageText?.validationMessages
                            ?.pleaseEnterPhoneOrMobileNumber,
                    }}
                  />
                </Grid>
                {!showGuardianFields && (
                  <>
                    <Grid xs={12} sm={6} className="field">
                      <Input
                        name="email"
                        control={control}
                        placeholder={
                          pageText?.validationMessages?.pleaseEnterEmailAddress
                        }
                        errors={errors}
                        outsideError={
                          emailError
                            ? pageText?.validationMessages
                                .emailAddressIsNotValid
                            : undefined
                        }
                        label={`${pageText?.labelsMetadata?.emailAddressLabel} *`}
                        onEmailChange={(e: any) => {
                          if (!e.target.value) {
                            setEmailError(false);
                          } else {
                            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            setEmailError(!emailPattern.test(e.target.value));
                            setEmailValue(e.target.value);
                          }
                          handleEmailChange(e);
                        }}
                        rules={{
                          required:
                            pageText?.validationMessages
                              ?.pleaseEnterEmailAddress,
                        }}
                      />
                    </Grid>
                    <Grid xs={12} sm={6} className="field">
                      <Input
                        name="confirmEmail"
                        control={control}
                        placeholder={
                          pageText?.validationMessages?.pleaseEnterEmailAddress
                        }
                        errors={errors}
                        outsideError={
                          confirmEmailError
                            ? getConfirmEmail
                              ? pageText?.validationMessages
                                  .emailAndConfirmEmailAddressDoesNotMatching
                              : pageText?.validationMessages
                                  .pleaseEnterConfirmEmailAddress
                            : undefined
                        }
                        label={`${pageText?.labelsMetadata?.confirmEmailAddressLabel} *`}
                        onEmailChange={(e: any) => {
                          setConfirmEmail(e.target.value);
                          if (emailValue === e.target.value) {
                            handleEmailChange(e);
                            setConfirmEmailError(false);
                          } else {
                            setConfirmEmailError(true);
                          }
                          if (!e.target.value) {
                            setConfirmEmailError(false);
                          }
                        }}
                        rules={{
                          required:
                            pageText?.validationMessages
                              ?.pleaseEnterConfirmEmailAddress,
                        }}
                      />
                    </Grid>
                  </>
                )}
              </FormSectionGrid>
            </Box>
            <Box id="examReason">
              <FormSectionHeader>
                {pageText?.textMetadata?.reasonforexamtext}
              </FormSectionHeader>
              <FormSectionGrid>
                <Grid xs={12} sm={6} className="field">
                  <Select
                    label={`${pageText?.labelsMetadata?.reasonForExamLabel} *`}
                    classNamePrefix={"form_drop"}
                    placeholder={`${pageText?.labelsMetadata?.reasonForExamLabel}`}
                    options={lookupDropdownData?.reasons}
                    control={control}
                    errors={errors}
                    name="examReason"
                    onCustomChange={(e: any) => {
                      if (
                        e.value === "1" &&
                        examDetails?.isExamEligibleForUkVisa
                      ) {
                        setUkVisa(true);
                      } else {
                        setUkVisa(false);
                        setValue("VoiceConsent", false);
                        setValue("UkbaConsent", false);
                        setValue("PassportNo", "");
                        setValue("passportEx", {
                          day: "",
                          month: "",
                          year: "",
                        });
                      }
                    }}
                    rules={{
                      required: {
                        value: true,
                        message:
                          pageText?.validationMessages
                            ?.pleaseSelectReasonForExam,
                      },
                    }}
                  />
                </Grid>
                <Grid
                  xs={12}
                  md={6}
                  className="field"
                  sx={{ display: { xs: "none", sm: "initial" } }}
                />
                {(ukVisa ||
                  country?.label === "Morocco" ||
                  country?.label === "Myanmar" ||
                  country?.label === "Hong Kong") && (
                  <Passport
                    control={control}
                    errors={errors}
                    pageText={pageText}
                    setAge={setAge}
                    DayList={DayList}
                    getLanguageCode={getLanguageCode}
                  />
                )}
              </FormSectionGrid>
            </Box>
            {examRulesData?.examRegistrationRules?.displaySpecialNeeds && (
              <Box id="specialRequest">
                <FormSectionHeader>
                  {pageText?.textMetadata?.specialrequirementtext}
                </FormSectionHeader>
                <FormSectionGrid>
                  <Grid xs={12} sm={6} className="field">
                    <Select
                      label={`${pageText?.labelsMetadata?.anySpecialRequirementsLabel} *`}
                      classNamePrefix={"form_drop"}
                      placeholder={`${pageText?.labelsMetadata?.selectText}`}
                      options={lookupDropdownData?.specialRequirements}
                      control={control}
                      errors={errors}
                      name="specialRequestType"
                      onCustomChange={(e: any) => {
                        setRequestType(e.value === "1" ? true : false);
                      }}
                      rules={{
                        required: {
                          value: true,
                          message:
                            pageText?.validationMessages
                              ?.pleaseSelectSpecialRequirements,
                        },
                      }}
                    />
                  </Grid>
                  {requestType && (
                    <Grid xs={12} className="field">
                      <Input
                        name="specialRequestMessage"
                        label={
                          pageText?.labelsMetadata?.specialrequirementhinttext
                            ? `${pageText?.labelsMetadata?.specialrequirementhinttext} *`
                            : ""
                        }
                        placeholder={
                          pageText?.labelsMetadata?.specialrequirementhinttext
                        }
                        control={control}
                        errors={errors}
                        maxLength={1000}
                        rules={{
                          required: {
                            value: requestType ? true : false,
                            message:
                              pageText?.labelsMetadata?.specialRequirementError,
                          },
                        }}
                      />
                    </Grid>
                  )}
                </FormSectionGrid>
              </Box>
            )}
            {examRulesData?.examRegistrationRules
              ?.isThirdPartyInvoiceEnabled && (
              <Box id="thirdParty">
                <FormSectionHeader>
                  {pageText?.labelsMetadata?.thirdpartysection}
                </FormSectionHeader>
                <FormSectionGrid>
                  <Grid xs={12} sm={6} className="field">
                    <Select
                      label={`${pageText?.labelsMetadata?.enableThirdPartyInvoiceLabel} *`}
                      classNamePrefix={"form_drop"}
                      placeholder={`${pageText?.labelsMetadata?.selectText}`}
                      options={lookupDropdownData?.specialRequirements}
                      control={control}
                      errors={errors}
                      name="enableThirdParty"
                      onCustomChange={(e: any) => {
                        setShowThirdParty(e.value === "1" ? true : false);
                      }}
                      rules={{
                        required: {
                          value: true,
                          message:
                            pageText?.validationMessages
                              ?.pleaseSelectEnableThirdPartyInvoice,
                        },
                      }}
                    />
                  </Grid>
                  <Grid
                    xs={12}
                    sm={6}
                    className="field"
                    sx={{ display: { xs: "none", sm: "initial" } }}
                  />
                  {showThirdParty && (
                    <>
                      <Grid xs={12} sm={6} className="field">
                        <Select
                          label={`${pageText?.labelsMetadata?.isThirdPartyACompanyLable} *`}
                          classNamePrefix={"form_drop"}
                          placeholder={`${pageText?.labelsMetadata?.selectText}`}
                          options={lookupDropdownData?.specialRequirements}
                          control={control}
                          errors={errors}
                          name="isThirdPartyCompany"
                          onCustomChange={(e: any) => {
                            setShowCompanyThirdParty(
                              e.value === "1" ? true : false
                            );
                          }}
                          rules={{
                            required: {
                              value: true,
                              message:
                                pageText?.validationMessages
                                  ?.pleaseSelectIsThirdPartyACompany,
                            },
                          }}
                        />
                      </Grid>
                      <Grid xs={12} sm={6} className="field">
                        {showCompanyThirdParty && (
                          <Input
                            name="fiscalNumber"
                            type="text"
                            control={control}
                            placeholder={
                              pageText?.labelsMetadata
                                ?.fiscalIdentificationNumberLabel
                            }
                            errors={errors}
                            label={`${pageText?.labelsMetadata?.fiscalIdentificationNumberLabel} *`}
                            rules={{
                              required:
                                pageText?.validationMessages
                                  ?.pleaseEnterFiscalIndentificationNumber,
                            }}
                          />
                        )}
                      </Grid>
                      <Grid xs={12} sm={6} className="field">
                        <Input
                          name="payeeName"
                          type="text"
                          control={control}
                          placeholder={
                            pageText?.labelsMetadata?.nameOfPayeeOrCompanyLabel
                          }
                          errors={errors}
                          label={`${pageText?.labelsMetadata?.nameOfPayeeOrCompanyLabel} *`}
                          rules={{
                            required:
                              pageText?.validationMessages
                                ?.pleaseEnterNameOfPayeeOrCompany,
                          }}
                        />
                      </Grid>
                      <Grid xs={12} sm={6} className="field">
                        <Input
                          name="thirdPartyAddress"
                          type="text"
                          control={control}
                          placeholder={
                            pageText?.labelsMetadata
                              .addressOrCompanyAddressLabel
                          }
                          errors={errors}
                          label={`${pageText?.labelsMetadata.addressOrCompanyAddressLabel} *`}
                          rules={{
                            required:
                              pageText?.validationMessages
                                ?.pleaseEnterAddressOrCompanyAddress,
                          }}
                        />
                      </Grid>
                      <Grid xs={12} sm={6} className="field">
                        <Input
                          name="thirdPartyPostCode"
                          type="text"
                          control={control}
                          placeholder={`${pageText?.labelsMetadata.postcodeLabel}`}
                          errors={errors}
                          label={`${pageText?.labelsMetadata.postcodeLabel} *`}
                          rules={{
                            required: `${pageText?.validationMessages.pleaseEnterThirdPartyPostcode}`,
                          }}
                        />
                      </Grid>
                      <Grid xs={12} sm={6} className="field">
                        <Input
                          name="thirdPartyCity"
                          type="text"
                          control={control}
                          placeholder={pageText?.labelsMetadata.cityLabel}
                          errors={errors}
                          label={`${pageText?.labelsMetadata.cityLabel} *`}
                          rules={{
                            required:
                              pageText?.validationMessages
                                ?.pleaseEnterThirdPartyCity,
                          }}
                        />
                      </Grid>
                      <Grid xs={12} sm={6} className="field">
                        <Select
                          label={`${pageText?.labelsMetadata.countryLabel} *`}
                          classNamePrefix={"form_drop"}
                          placeholder={`- ${pageText?.labelsMetadata?.selectText} -`}
                          options={lookupDropdownData?.countries}
                          control={control}
                          errors={errors}
                          name="thirdPartyCountry"
                          rules={{
                            required: {
                              value: true,
                              message:
                                pageText?.validationMessages
                                  .pleaseSelectThirdPartyCountry,
                            },
                          }}
                        />
                      </Grid>
                    </>
                  )}
                </FormSectionGrid>
              </Box>
            )}
            {examRulesData?.examRegistrationRules?.isEIIIntegrationEnabled && (
              <Box id="invoiceInfo">
                <FormSectionHeader>
                  {pageText?.textMetadata?.invoicedetailstext}
                </FormSectionHeader>
                <Box sx={{ marginTop: "20px", fontSize: "14px" }}>
                  {pageText?.labelsMetadata.invoiceHeadingLabel}
                </Box>
                <Box mt={2}>
                  <Box width="100%">
                    <RadioLabelGroup
                      name="invoiceType"
                      control={control}
                      errors={errors}
                      options={invoiceTypes}
                      onCustomChange={(e: any) => {
                        setInvoiceType(e.target.value);
                        setValue("another", {
                          taxNumber: "",
                          givenName: "",
                          surname: "",
                          phoneNo: "",
                          email: "",
                          country: "",
                          address: "",
                          addressLine2: "",
                          postCode: "",
                          city: "",
                        });
                        setValue("company", {
                          taxNumber: "",
                          companyName: "",
                          phoneNo: "",
                          email: "",
                          country: "",
                          address: "",
                          addressLine2: "",
                          postCode: "",
                          city: "",
                        });
                        setValue("myself.taxNumber", "");
                        setGivenNameEnable(false);
                        setTaxNumber(false);
                      }}
                    />
                  </Box>
                </Box>
                <Box>{invoiceFormRender[invoiceType]}</Box>
              </Box>
            )}
            <FormSectionHeader>
              {pageText?.textMetadata?.informationnotestext}
            </FormSectionHeader>
            <Box sx={styles.infoBox}>
              {examRulesData?.examRegistrationRules?.isPrivacyPolicyEnabled && (
                <>
                  <Box className="para">
                    <Box className="para_head">
                      {pageText?.labelsMetadata.privacyNotice}
                    </Box>
                    <Box className="para_text">
                      <Box
                        dangerouslySetInnerHTML={{
                          __html:
                            pageText?.labelsMetadata?.privacyNoticeParagraph,
                        }}
                      ></Box>
                    </Box>
                  </Box>
                  <Box className="para">
                    <Box className="para_head">
                      {pageText?.labelsMetadata.dataProtection}
                    </Box>
                    <Box className="para_text">
                      <Box
                        dangerouslySetInnerHTML={{
                          __html:
                            pageText?.labelsMetadata.dataProtectionParagraph,
                        }}
                      ></Box>
                    </Box>
                  </Box>
                </>
              )}
              {examRulesData?.examRegistrationRules
                ?.isMarketingConsentEnabled && (
                <>
                  <Box className="para">
                    <Box className="para_head">
                      {pageText?.labelsMetadata.marketingConsent}
                    </Box>
                  </Box>
                  <Box mt={1}>
                    <RadioLabelGroup
                      name="MarketingConsent"
                      row={false}
                      control={control}
                      errors={errors}
                      options={marketingOptions}
                      rules={{
                        required: {
                          value: true,
                          message: pageText?.labelsMetadata?.pleaseselectoption,
                        },
                      }}
                    />
                  </Box>
                  <Box className="para">
                    <Box className="para_head">
                      {pageText?.labelsMetadata.disclaimer}
                    </Box>
                  </Box>
                </>
              )}
            </Box>
            {russiaSelected && <RussiaWarningMsg />}
            <Box className="seperator"></Box>
            <Stack direction={{ sm: "row" }} gap={2} py={2}>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIosIcon />}
                onClick={() => toggleSteps("examDetails", 1)}
              >
                {pageText?.buttonsMetadata?.previousStep}
              </Button>
              <Button variant="text" onClick={() => toggleSteps("location", 0)}>
                {pageText?.buttonsMetadata?.cancelButtonText}
              </Button>
              <Button
                type="submit"
                variant="contained"
                endIcon={<ArrowForwardIosIcon />}
                onClick={() => {
                  setTimeout(() => {
                    errorAutoScroll();
                  }, 400);
                }}
                sx={{ ml: { sm: "auto" } }}
              >
                {pageText?.buttonsMetadata?.nextButtonText}
              </Button>
            </Stack>
          </Box>
        </Paper>
      </Stack>
      <Popup open={open} handleClose={handleClose}>
        <Box>
          <Box sx={styles.modalBody}>
            <Box
              dangerouslySetInnerHTML={{
                __html: showMinAge
                  ? examRulesData?.examRegistrationRules?.minAgeMessage
                  : examRulesData?.examRegistrationRules?.maxAgeMessage,
              }}
            ></Box>
          </Box>
          <Stack direction="row" justifyContent="center">
            <Button variant="contained" onClick={handleClose}>
              {pageText?.buttonsMetadata?.okButtonText}
            </Button>
          </Stack>
        </Box>
      </Popup>

      <NoSlotsChecker
        pageText={pageText}
        venueExamGuid={examDetails?.examId}
        toggleSteps={toggleSteps}
      />
    </>
  );
};

export default CandidateDetails;
